import { makeStyles } from '@material-ui/core/styles';

export default makeStyles({
  section: {
    marginTop: '100px'
  },
  makequizbutton: {
    padding: '10px 20px',
    fontSize: '30px',
    textTransform: 'none'
  },
  quizcodesection: {
    display: 'flex',
    alignItems: 'center'
  },
  quizcodesectionbutton: {
    padding: '15px',
    marginLeft: '10px'
  }
});
